import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Τελεία «άλλαξε» στο χρώμα της εφαρμογής. aria-hidden: μέσα σε ετικέτα πεδίου ένα κείμενο θα άλλαζε
 * το όνομα του πεδίου (getByLabelText, αναγνώστες οθόνης) τη στιγμή που γράφεις.
 */
const ChangedDot: React.FC = () => {
  const { t } = useTranslation(['settings']);
  return <span className="xs-dot" aria-hidden="true" title={t('settings:sheet.changed')} data-testid="sheet-changed-dot" />;
};

export default ChangedDot;
